module.exports = __webpack_public_path__ + "static/media/business_operator_recommender.61b80681.png";